import type { CustomerGender } from "../../protos/shared/shared.types";

export enum AuthenticationType {
  INVALID = 0,
  PASSWORD = 1,
  FACEBOOK = 2,
  APPLE = 3,
}

export interface CheckoutCustomer {
  id: number;
  // Can be empty
  firstName: string;
  email: string;
  gender: CustomerGender;
  isNewCustomer: boolean;
  emailHashes: EmailHashes;
  birthday: Date;
  authenticationType: AuthenticationType;
  phone: string;
  lastName: string;
}

export interface EmailHashes {
  // Creates a SHA256 hash of the email
  //
  // Also called 'internal'
  emh: string;
  // Hashes the mail using MD5, then SHA256.
  //
  // Also called 'criteo'
  emhec: string;
}
